const HidePasswordIcon: React.FC = () => (
    <svg width="22" height="20" viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M2.98014 6.22257C2.05704 7.31382 1.35263 8.59601 0.93457 10.0015C2.22587 14.338 6.24332 17.5 10.9993 17.5C11.9919 17.5 12.9523 17.3623 13.8625 17.1049M5.22784 4.22763C6.8841 3.13558 8.86792 2.5 11.0002 2.5C15.7562 2.5 19.7736 5.66205 21.0649 9.99852C20.353 12.3919 18.8108 14.4277 16.7722 15.772M5.22784 4.22763L2.00021 1M5.22784 4.22763L8.87889 7.87868M16.7722 15.772L20.0002 19M16.7722 15.772L13.1215 12.1213M13.1215 12.1213C13.6644 11.5784 14.0002 10.8284 14.0002 10C14.0002 8.34315 12.6571 7 11.0002 7C10.1718 7 9.42179 7.33579 8.87889 7.87868M13.1215 12.1213L8.87889 7.87868"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

HidePasswordIcon.displayName = 'HidePasswordIcon'

export default HidePasswordIcon
